module.exports = __webpack_public_path__ + "9308c92e36fdecc0fb8501eee7bf42dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colour_diamond_ring.png
// module id = 337
// module chunks = 0